module.exports = __webpack_public_path__ + "static/img/yl-2.31d7062.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/yl-2.gif
// module id = 3S3w
// module chunks = 14